<template>
<form action="eqtlSnps" method="get" class="form-inline">
    <fieldset>
        <span>SNP ID : </span>
        <div id="search_input" style="display:inline-flex">
            <input name="snp_id" type="text" class="form-control mr-sm-2" placeholder="rs" autocomplete="off">
            <span class="input-group-btn">
                <button type="submit" class="btn btn-warning">Search</button>
            </span>
        </div>
        <div v-if="showInputMessage != ''" class="search_input_help">
            <small class="text-muted">
                {{ this.showInputMessage }}
            </small>
        </div>
    </fieldset>
</form>
</template>

<script>
export default {
    data() {
        return {
            showInputMessage: ''
        }
    },
}
</script>

<style>
    #search_input .form-control {
        margin-right: 5px;
    }
</style>
